import React from 'react';
import { IoPersonOutline, IoWalletOutline, IoCalendarOutline, IoChevronDownOutline, IoChevronForwardOutline, IoEyeOutline } from 'react-icons/io5';

const levelClasses = {
  0: 'badge-gold',
  1: 'badge-blue',
  2: 'badge-purple',
  3: 'badge-emerald',
};

// Level names removed to favor pure numeric Lvl 0, 1, 2 sequence per user request.

export const NetworkUserCard = ({ user, isExpanded, onToggle, onShowDetails, isRoot = false }) => {
  const hasChildren = user.children && user.children.length > 0;
  
  const fullWallet = user.wallet || "0x0000000000000000000000000000000000000000";
  const formattedWallet = fullWallet.length > 12 
    ? `${fullWallet.substring(0, 6)}...${fullWallet.substring(fullWallet.length - 4)}` 
    : fullWallet;

  return (
    <div 
      onClick={hasChildren ? (e) => { e.stopPropagation(); onToggle(); } : undefined}
      className={`user-card-glass ${isExpanded ? 'expanded' : ''} ${isRoot ? 'root-node' : ''} ${hasChildren ? 'interactive' : ''} ${user.isSearchedTarget ? 'searched-target-glow' : ''}`}
    >
      <div className="d-flex align-items-start justify-content-between mb-3">
        <div className="d-flex align-items-center gap-2" style={{ minWidth: 0, flex: 1 }}>
          <div style={{ padding: '10px', borderRadius: '50%', background: 'rgba(0,0,0,0.05)', color: '#4b5563', flexShrink: 0 }}>
            <IoPersonOutline size={20} />
          </div>
          <div style={{ minWidth: 0 }}>
            <h3 
              className="user-card-title" 
              data-tooltip-id="tree-tooltip" 
              data-tooltip-content={user.name}
            >
              {user.name}
            </h3>
            <p 
              className="user-card-wallet" 
              data-tooltip-id="tree-tooltip" 
              data-tooltip-content={fullWallet}
            >
              <IoWalletOutline size={12} /> {formattedWallet}
            </p>
          </div>
        </div>
        <div className="d-flex align-items-center gap-2">
          <span 
            className={`user-card-level-badge ${levelClasses[user.level] || (user.level < 0 ? 'badge-gold' : 'badge-emerald')}`}
          >
            Lvl {user.level + 1}
          </span>
          <button 
            type="button"
            onClick={(e) => { e.stopPropagation(); onShowDetails(user); }}
            className="btn btn-sm btn-link p-0 text-muted"
            title="View Details"
          >
            <IoEyeOutline size={18} />
          </button>
        </div>
      </div>
      
      <div className="user-card-footer">
        <div className="d-flex align-items-center gap-1">
          <IoCalendarOutline size={12} />
          {user.joinDate}
        </div>
        
        {hasChildren && (
          <div className="referral-pill">
            {isExpanded ? <IoChevronDownOutline size={14} /> : <IoChevronForwardOutline size={14} />}
            <span>{user.children.length} {user.children.length === 1 ? 'Referral' : 'Referrals'}</span>
          </div>
        )}
      </div>
    </div>
  );
};
